<!-- @format -->

<div class="sectionHeader" (click)="filterObject.toggleFilter(id, $event)" *ngIf="filter.filter.visible">
  <div class="spacer">
    <ng-content></ng-content>
  </div>
  <div>
    <fa-icon [icon]="faChevronDown" *ngIf="!filterObject.section[id]"></fa-icon>
    <fa-icon [icon]="faChevronUp" *ngIf="filterObject.section[id]"></fa-icon>
  </div>
</div>
<div class="sectionBody" *ngIf="filterObject.section[id]">
  <div class="ctlSearchBar" *ngIf="search">
    <div class="searchField  w-full">
      <fa-icon matPrefix icon="search" class="searchIcon"></fa-icon>
      <input matInput (keyup)="applyFilter($any($event.target).value)" placeholder="{{ _common.search }}" #_search />
      <fa-icon icon="times" matSuffix (click)="clearFilter(_search)" class="clearSearch"></fa-icon>
    </div>
  </div>
  <ng-container *ngFor="let v of filter.values; let i = index">


    <div *ngIf="!search || _filter(filter.names[i])" mat-menu-item (click)="filter.filter.toggle(v, $event); refresh()">
      <mat-checkbox (change)="toggle(v, $event)" [(ngModel)]="filter.filter.v[v]" (click)="$event.stopPropagation()">
      </mat-checkbox>
      {{ filter.names[i] }}
    </div>
  </ng-container>

  <div class="bottom">
    <div class="button" (click)="filter.filter.clear(); refresh()">
      {{ _common.clear }}
    </div>
  </div>
</div>